// 存储全局变量并提供读写接口

class User {
  constructor({ identifier = '' } = {}) {
    this.identifier = identifier;
  }
}
// 每次接口请求需要带上的身份数据
let __user = new User();
export const getUser = () => __user;
export const setUser = user => {
  __user = new User(user);
};

// 存放知识记录，用于在不同地方更新知识阅读数
let __article = {};
export const getArticle = () => __article;
export const setArticle = article => {
  __article = article;
};

